<template>
  <div class="product-gallery-swiper">
    <div
      v-swiper-gallery
      class="swiper-container swiper-container--images">
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          v-for="(realization, index) of realizations"
          :key="index"
          class="swiper-slide">
          <img :src="realization.fields.image.fields.file.url" />
          <p v-if="typeof realization.fields.didascalia !== 'undefined'">
            {{ realization.fields.didascalia }}
          </p>
          <p v-else>&nbsp;</p>
        </div>
        <!-- Fine Slides -->
      </div>
    </div>
    <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
  </div>
</template>

<script>

import swiper from './swiper'
export default {
  name: 'ProductGallerySwiper',
  mixins: [swiper],
  props: {
    realizations: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
